"use client";

import { BlocksProductDescription } from "../../../../__generated__/contentful-types";
import { useImageLoading } from "../../../../helpers/ImageLoadingContext";
import { slugifyTitle } from "../../../../helpers/contentful/slugifyTitle";
import { notNull } from "../../../../helpers/notNull";
import { responsiveImageHelper } from "../../../../helpers/responsiveImageHelper";
import { DropdownList } from "../../dropdown-list/dropdown-list";
import { CosmosButton, CosmosIconChevronRight } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./product-description.module.css";

const cx = classNames.bind(styles);

export const ProductDescription = ({
  block,
}: {
  block: BlocksProductDescription;
}) => {
  const imageLoading = useImageLoading();

  return (
    <div
      className={cx("container")}
      id={
        block.title && slugifyTitle(block.title) !== "-"
          ? slugifyTitle(block.title)
          : "ingredients"
      }
    >
      <div className={cx("inner")}>
        <div className={cx("main")}>
          {block.artwork?.url && (
            <div className={cx("image")}>
              <div className={cx("can-wrapper")}>
                <img
                  loading={imageLoading}
                  srcSet={responsiveImageHelper.createContentfulSrcSet(
                    block.artwork.url,
                  )}
                  sizes="210px"
                  className={cx("can")}
                  alt={block.artwork.description ?? ""}
                />
              </div>
            </div>
          )}
          <div className={cx("ingredients")}>
            <h2 className={cx("title")}>{block.title}</h2>
            <DropdownList
              items={block.ingredientsCollection?.items.filter(notNull) || []}
            />
            {((block.linkUrl && block.linkText) ||
              (block.link2Url && block.link2Text)) && (
              <div className={cx("button-wrapper")}>
                {block.linkUrl && block.linkText && (
                  <CosmosButton
                    href={block.linkUrl ?? undefined}
                    kind="primary"
                    width="full@small content@medium"
                    size="large"
                    className={cx("button")}
                  >
                    {block.linkText}
                  </CosmosButton>
                )}
                {block.link2Url && block.link2Text && (
                  <CosmosButton
                    href={block.link2Url ?? undefined}
                    size="large"
                    kind="link"
                    icon-placement="after"
                    className={cx("button")}
                  >
                    <CosmosIconChevronRight
                      slot="icon"
                      className={cx("button-icon")}
                    />
                    {block.link2Text}
                  </CosmosButton>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
